const buildAudioRenderer = (content: string, mimeType: string, label: string) => {
  const cleaned = (content || '').replace(/\s+/g, '')
  const src = cleaned ? `data:${mimeType};base64,${cleaned}` : ''
  const fallback = cleaned ? '' : `No ${label} data available.`

  return `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <style>
      :root {
        color-scheme: light;
      }
      body {
        margin: 0;
        background: #ffffff;
        color: #64748b;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
        padding: 16px;
        box-sizing: border-box;
      }
      audio {
        width: min(560px, 100%);
      }
      .empty {
        font-size: 13px;
      }
    </style>
  </head>
  <body>
    ${src ? `<audio controls preload="metadata" src="${src}"></audio>` : `<div class="empty">${fallback}</div>`}
  </body>
</html>`
}

const mp3Renderer = (content: string) => buildAudioRenderer(content, 'audio/mpeg', 'MP3')

export const collectAssetReferences = () => []

export default mp3Renderer
